import { configureStore, isRejectedWithValue } from '@reduxjs/toolkit';
import type { Middleware } from '@reduxjs/toolkit';

import miscReducer from '#features/misc/misc.slice';
import authReducer from '#features/auth/auth.slice';
import collectionListReducer from '#features/collection/list.slice';
import collectionEditReducer from '#features/collection/Edit.slice';
import vendorListReducer from '#features/vendor/list.slice';
import productListReducer from '#features/product/list.slice';
import userListReducer from '#features/user/list.slice';
import orderListForUserDetailReducer from '#features/user/order.slice';
import shopListReducer from '#features/shop/list.slice';
import orderListReducer from '#features/order/order.slice';
import bulkOrderListReducer from '#features/order/bulk.slice';
import inventoryOrderListReducer from '#features/inventory/inventory.slice';
import invoiceListReducer from '#features/invoice/list.slice';
import reportTableReducer from '#features/inventory/reportTable.slice';
import receivingListReducer from '#features/receiving/receiving.slice';
import draftItemReducer from '#features/cart/draft.slice';
import appConfigReducer from '#features/app/config.slice';
import { api } from '#services/api';

const sessionErrorHandlerMiddleware: Middleware = () => (next) => (action) => {
  // TODO improvement
  if (isRejectedWithValue(action)) {
    const payload = action.payload as { originalStatus?: number } | undefined;
    if (payload && payload.originalStatus === 401) {
      // refresh page when api returns 401
      window.location.href = '/';
      return undefined;
    }
  }

  return next(action);
};

export const createStore = (options?: Record<string, unknown>) => configureStore({
  reducer: {
    appConfig: appConfigReducer,
    misc: miscReducer,
    auth: authReducer,
    collectionList: collectionListReducer,
    collectionEdit: collectionEditReducer,
    vendorList: vendorListReducer,
    productList: productListReducer,
    userList: userListReducer,
    orderListForUserDetail: orderListForUserDetailReducer,
    shopList: shopListReducer,
    orderList: orderListReducer,
    bulkOrderList: bulkOrderListReducer,
    inventoryOrderList: inventoryOrderListReducer,
    invoiceList: invoiceListReducer,
    reportTable: reportTableReducer,
    receivingList: receivingListReducer,
    draftItem: draftItemReducer,
    [api.reducerPath]: api.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware()
      .concat(sessionErrorHandlerMiddleware)
      .concat(api.middleware);
  },
  ...options,
});

export const store = createStore();
